module.exports = __webpack_public_path__ + "a548c6ccb0cfca553b546c2aef9c4439.MP3";